import { render, staticRenderFns } from "./new-home.vue?vue&type=template&id=3a52925e&"
import script from "./new-home.vue?vue&type=script&lang=js&"
export * from "./new-home.vue?vue&type=script&lang=js&"
import style0 from "./new-home.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports